/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

const RefreshButton = ({
  className,
  onClick,
  disabled = false,
  fontSize = "1.4rem"
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick?.();
    }
  };

  return (
    <div
      className={`${className ?? ""} help-icon d-inline-block`}
      onClick={handleClick}
      style={{ cursor: "pointer", fontSize: fontSize, color: disabled ? "#0006" : "#000F" }}
    >
      <i className="icon bi bi-arrow-clockwise" />
    </div>
  )
};

export default RefreshButton;
